let PackagesItem = [
    {
        trackTitle: "FULL Access 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "149",
        trackFullPrice: '800',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Live event + Recordings',
        trackLink: 'https://geekle.us/ticket/1673604255842x646545001543106600',
        // earlyBird: true,
    },
    {
        trackJunior: true,
        trackTitle: "Free Trial Package",
        trackSubtitle: "For Junior specialists",
        trackPrice: "0",
        trackFullPrice: '500',
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticketfree/1673604102920x696839831585554400',
        // earlyBird: true,
    },
    {
        trackTitle: "NO RECORDINGS access",
        trackSubtitle: "For Junior specialists",
        trackPrice: "79",
        trackNextPrice: "119",
        trackFullPrice: '500',
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticket/1679302146148x517904605918003200',
        // earlyBird: true,
    },
    {
        trackTitle: "2 Events Package",
        event1: "C Sharp and .NET Global Summit",
        event2: "AI in DevOps Conference 23",
        event2Link: "https://events.geekle.us/aidevops/",
        trackPrice: "149",
        trackFullPrice: '1000',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: '2 Live events + Recordings',
        trackLink: 'https://geekle.us/ticket/1690271833322x616097622802038800',
    },
    {
        trackTitle: "3 Events Package",
        event1: "C#/.NET Global Summit'23",
        event2: "GPTcoding for Frontend Developers Conference'23",
        event2Link: "https://events.geekle.us/gpt/",
        event3: "GPTcoding for Backend Developers Summit’23",
        event3Link: "https://events.geekle.us/gpt-backend/",
        trackPrice: "349",
        trackFullPrice: '1200',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Live event + Recordings',
        trackLink: 'https://geekle.us/ticket/1685965038795x613751039254593500',
        validDate: '9.06',
        inverseColors: true,
    },
];

export default PackagesItem;
